import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './BusinessTravelContent.css';

const BusinessTravelContent = () => {
  return (
    <>
        <div className="container bt-content">
            <div className="row px-lg-5 px-md-3 px-0">
                <div className="col-md-12">
                    <h1 className='headings'><span>Global </span>Business Travel Solutions Tailored to Your Needs</h1>
                    <p className='bt-content-1 mt-md-4 mt-3'>Seamless business travel is more important than ever. We simplify complex business travel programs, offering clear, practical solutions shaped to your detailed needs. Whether you're looking to optimize existing strategies or build a new program from scratch, we're here to guide you every step of the way.</p>
                    <p className='bt-content-1 mt-md-4 mt-3'>We provide comprehensive solutions for your growing business objectives, from cost optimization and traveler experience enhancement to compliance and sustainability. Come together and collaborate to create a travel program that's efficient, effective, and aligned with your company's perceptiveness. With its maximizing savings, boosting productivity, or achieving your sustainability targets, we're here to transform your corporate travel into a strategic asset that drives success. We are committed to transforming corporate travel into a valuable, strategic advantage that pushes your organization toward long-term success. With us, your journey isn’t just about reaching destinations; it’s about exceeding expectations.</p>
                </div>
            </div>
        </div>
    </>
  )
}

export default BusinessTravelContent